export default {
  rewards: {
    title: "Ganjaran",
    claim: "Tuntut",
    weeklyCashback: "Cashback Mingguan",
    weeklyCashbackDesc: "Dapatkan kembali sebahagian daripada kerugian mingguan anda setiap minggu.",
    dailySpin: "Pusingan Harian",
    dailySpinDesc: "Putar roda setiap hari untuk peluang memenangi hadiah besar.",
    invitationBonus: "Bonus Jemputan",
    invitationBonusDesc: "Jemput rakan dan dapatkan ganjaran bagi setiap yang menyertai.",
    rebate: "Rebat",
    rebateDesc: "Dapatkan rebat pada setiap pertaruhan, menang atau kalah.",
    bannerTitle: "GANJARAN",
    bannerSubtitle: "Selesaikan tugas dan dapatkan ganjaran yang hebat!",
    sectionTitle: "Ganjaran Hebat Anda",
    goNow: "Pergi Sekarang",
    historyReceived: "Jumlah diterima",
    todayReceived: "Diterima hari ini",
    cashbackDialog: {
      title: "Pulangan Tunai Pertaruhan",
      loading: "Memuatkan...",
      empty: "Tiada peraturan pulangan tunai",
      level: "Tahap",
      amountRange: "Julat Jumlah",
      rewardRate: "Kadar Ganjaran",
      rewardCap: "Had Ganjaran",
    },
    cards: {
      checkin: {
        title: "Daftar Masuk Harian",
        subtitle: "Log masuk untuk daftar masuk setiap hari",
        description: "Pemain, jangan lupa daftar masuk setiap hari~",
      },
      cashback: {
        title: "Cashback",
        subtitle: "Ganjaran rebat platform",
      },
      rescue: {
        title: "Bonus Penyelamat",
        subtitle: "Main 3 permainan tunai",
        description: "Dana penyelamat untuk pemain yang muflis",
      },
      task: {
        title: "Tugas",
        subtitle: "Selesaikan tugas platform",
        description: "Tugas platform",
      },
      balance: {
        title: "Peti Besi",
        subtitle: "Dapatkan faedah harian",
        description: "Peti besi platform",
      },
      loan: {
        title: "Bonus Pinjaman",
        subtitle: "Meminjam dengan mudah",
        description: "Pinjaman platform",
      },
    },
    checkIn: {
      dailySignIn: "DAFTAR MASUK HARIAN",
      totalRewards: "JUMLAH GANJARAN",
      headlineDaysBefore: "Daftar masuk selama",
      headlineDaysAfter: "hari,",
      headlineTailCumulative: "terlepas sehari tidak mengapa.",
      headlineTailDate: "terlepas sehari akan hilang ganjaran hari itu.",
      headlineCumulative: "Daftar masuk selama {days} hari untuk hadiah besar, terlepas sehari tidak mengapa.",
      headlineDate: "Daftar masuk selama {days} hari, terlepas sehari akan hilang ganjaran hari itu.",
      headlineEmpty: "Daftar masuk untuk memenangi ganjaran",
      title: "Daftar Masuk",
      modeCumulative: "Daftar Masuk Terkumpul",
      modeDate: "Daftar Masuk Ikut Tarikh",
      rewards: "Ganjaran",
      signedIn: "Telah daftar",
      day: "Hari {n}",
      loading: "Memuatkan...",
      empty: "Tiada aktiviti daftar masuk yang aktif.",
      btnCheckIn: "Daftar Masuk",
      btnSigned: "Telah Daftar",
      btnLocked: "Terkunci",
      claimSuccess: "Daftar masuk berjaya, ganjaran {amount} {currency} dikreditkan",
      claimFailed: "Daftar masuk gagal",
      alreadySigned: "Anda telah daftar masuk hari ini",
      notLogin: "Sila log masuk dahulu",
    },
  },
};
